(function () {
  if (window.__AmorosaReviewsInitialized) return;
  window.__AmorosaReviewsInitialized = true;

  var APP_ORIGIN = 'https://amorosa-reviews.zcmarketing.au';

  function ensureStylesInserted() {
    if (document.getElementById('amorosa-reviews-styles')) return;
    // Use opacity-based fade instead of display:none to allow transitions
    var css = '' +
      '.amorosa-review-root{position:relative;width:100%;}' +
      '.amorosa-review-viewport{position:relative;overflow:hidden;width:100%;}' +
      '.amorosa-review-track{position:relative;width:100%;min-height:1px;}' +
      '.amorosa-review-slide{position:absolute;inset:0;opacity:0;transition:opacity .3s ease;}' +
      '.amorosa-review-slide.is-active{position:relative;opacity:1;}' +
      // Arrows: visible on desktop via media query; dimensions/colours overridden inline from settings
      '.amorosa-review-nav{position:absolute;top:50%;transform:translateY(-50%);display:none;align-items:center;justify-content:center;border-radius:999px;cursor:pointer;}' +
      '.amorosa-review-nav[disabled]{opacity:.35;cursor:default;}' +
      '.amorosa-review-nav.prev{left:0;}' +
      '.amorosa-review-nav.next{right:0;}' +
      '@media (min-width: 990px){.amorosa-review-nav{display:flex;}}';
    var style = document.createElement('style');
    style.id = 'amorosa-reviews-styles';
    style.type = 'text/css';
    style.appendChild(document.createTextNode(css));
    document.head.appendChild(style);
  }

  function px(v, fallback) {
    var val = (v == null ? fallback : v);
    return val + (typeof val === 'number' ? 'px' : '');
  }

  function createCard(review, s) {
    var btn = document.createElement('button');
    btn.className = 'quickview-button';
    btn.id = review.id;
    btn.type = 'button';

    // Card container styles
    btn.style.backgroundColor = s.cardBg || '#fff';
    btn.style.borderRadius = px(s.cardRadius, 12);
    btn.style.padding = px(s.cardPadding, 12);
    if (s.cardPaddingTop != null) btn.style.paddingTop = px(s.cardPaddingTop, 0);
    if (s.cardPaddingRight != null) btn.style.paddingRight = px(s.cardPaddingRight, 0);
    if (s.cardPaddingBottom != null) btn.style.paddingBottom = px(s.cardPaddingBottom, 0);
    if (s.cardPaddingLeft != null) btn.style.paddingLeft = px(s.cardPaddingLeft, 0);

    // Horizontal row
    var row = document.createElement('div');
    row.style.display = 'flex';
    row.style.gap = px(s.contentGap, 12);
    row.style.alignItems = 'center'; // ensure vertical centring of image/text
    var ta = (s.textAlign || 'left');
    row.style.justifyContent = (ta === 'center' ? 'center' : (ta === 'right' ? 'flex-end' : 'flex-start'));
    btn.appendChild(row);

    // Image
    var img = document.createElement('img');
    img.src = review.imageUrl;
    img.alt = review.nickname || '';
    img.style.width = px(s.imageSize, 48);
    img.style.height = px(s.imageSize, 48);
    img.style.objectFit = 'cover';
    img.style.borderRadius = px(s.imageRadius, 8);
    row.appendChild(img);

    // Text
    var text = document.createElement('div');
    text.style.flex = '1';

    var name = document.createElement('div');
    name.textContent = review.nickname || '';
    name.style.fontSize = px(s.nameFontSize, 14);
    name.style.fontWeight = String(s.nameFontWeight == null ? 600 : s.nameFontWeight);
    name.style.color = s.nameColor || '#111';
    name.style.textAlign = ta;

    var p = document.createElement('p');
    p.style.marginTop = px(s.nameReviewGap, 4);
    p.style.fontSize = px(s.reviewFontSize, 14);
    p.style.lineHeight = String(s.reviewLineHeight == null ? 1.4 : s.reviewLineHeight);
    p.style.letterSpacing = px(s.letterSpacing, 0);
    p.style.fontWeight = String(s.reviewFontWeight == null ? 400 : s.reviewFontWeight);
    p.style.color = s.reviewColor || '#111';
    p.style.display = '-webkit-box';
    p.style.webkitBoxOrient = 'vertical';
    p.style.webkitLineClamp = String(s.maxLines == null ? 3 : s.maxLines);
    p.style.overflow = 'hidden';
    p.style.paddingRight = px(s.reviewPaddingRight, 0);
    p.style.textAlign = ta;
    p.innerHTML = '<strong>"</strong>' + (review.reviewText || '') + '<strong>"</strong>';

    text.appendChild(name);
    text.appendChild(p);
    row.appendChild(text);
    // Navigate to reviews section when a card is clicked
    btn.addEventListener('click', function () {
      var target = document.getElementById('looxReviews');
      if (target && typeof target.scrollIntoView === 'function') {
        try {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {
          target.scrollIntoView();
        }
      } else {
        try {
          window.location.hash = 'looxReviews';
        } catch (e) { /* noop */ }
      }
    });
    return btn;
  }

  function renderInstance(root) {
    var limit = Number(root.getAttribute('data-limit') || '8');
    ensureStylesInserted();

    Promise.all([
      fetch(APP_ORIGIN + '/api/module/settings', { credentials: 'omit' }).then(function (r) { return r.json(); }),
      fetch(APP_ORIGIN + '/api/module/reviews?limit=' + encodeURIComponent(limit), { credentials: 'omit' }).then(function (r) { return r.json(); })
    ]).then(function (results) {
      var s = results[0] || {};
      var reviews = Array.isArray(results[1]) ? results[1] : [];
      if (!reviews.length) return;

      // Root structure
      root.innerHTML = '';
      root.className = (root.className || '') + ' amorosa-review-root';

      var viewport = document.createElement('div');
      viewport.className = 'amorosa-review-viewport';
      var track = document.createElement('div');
      track.className = 'amorosa-review-track';
      track.style.position = 'relative';
      viewport.appendChild(track);
      root.appendChild(viewport);

      var slides = [];
      for (var i = 0; i < reviews.length; i++) {
        var slide = document.createElement('div');
        slide.className = 'amorosa-review-slide';
        slide.appendChild(createCard(reviews[i], s));
        track.appendChild(slide);
        slides.push(slide);
      }

      // Nav (desktop only via CSS)
      var prev = document.createElement('button');
      prev.className = 'amorosa-review-nav prev';
      prev.setAttribute('aria-label', 'Previous review');
      prev.textContent = '‹';

      var next = document.createElement('button');
      next.className = 'amorosa-review-nav next';
      next.setAttribute('aria-label', 'Next review');
      next.textContent = '›';

      root.appendChild(prev);
      root.appendChild(next);

      // Arrow styling from settings (overrides CSS defaults)
      var arrowColor = s.arrowColor || '#111';
      var arrowBg = s.arrowBg || '#fff';
      var arrowBorder = s.arrowBorder || ('1px solid ' + arrowColor);
      var arrowSize = Number(s.arrowSize || 36);
      var arrowGap = Number(s.arrowGap || 8);
      var leftPos = s.leftPosition || 'center';
      var rightPos = s.rightPosition || 'center';

      function styleArrow(btn, pos, side) {
        btn.style.width = px(arrowSize);
        btn.style.height = px(arrowSize);
        btn.style.background = arrowBg;
        btn.style.border = arrowBorder;
        btn.style.color = arrowColor;
        btn.style.top = (pos === 'top' ? '0' : (pos === 'center' ? '50%' : 'auto'));
        btn.style.bottom = (pos === 'bottom' ? '0' : 'auto');
        btn.style.transform = (pos === 'center' ? 'translateY(-50%)' : '');
        // Slight negative offset to sit outside the card area if desired
        btn.style[side] = px(-(arrowSize + arrowGap));
      }
      styleArrow(prev, leftPos, 'left');
      styleArrow(next, rightPos, 'right');

      // Behaviour
      var index = 0;
      function update() {
        for (var j = 0; j < slides.length; j++) {
          var active = (j === index);
          slides[j].classList.toggle('is-active', active);
        }
        var isMobile = window.matchMedia('(max-width: 767px)').matches;
        // infinite carousel: arrows never disabled; wrap handled in handlers
        prev.disabled = false;
        next.disabled = false;
        // hide arrows completely on mobile
        prev.style.display = isMobile ? 'none' : '';
        next.style.display = isMobile ? 'none' : '';
      }

      prev.addEventListener('click', function () { index = (index - 1 + slides.length) % slides.length; update(); });
      next.addEventListener('click', function () { index = (index + 1) % slides.length; update(); });

      // Keyboard support when focus is within root
      root.addEventListener('keydown', function (ev) {
        if (ev.key === 'ArrowLeft') { prev.click(); }
        if (ev.key === 'ArrowRight') { next.click(); }
      });

      // Mobile swipe + gentle auto‑advance
      var startX = null;
      viewport.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      viewport.addEventListener('touchend', function (e) {
        if (startX == null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (dx > 40) { index = (index - 1 + slides.length) % slides.length; update(); }
        if (dx < -40) { index = (index + 1) % slides.length; update(); }
        startX = null;
      }, { passive: true });

      var isMobile = window.matchMedia('(max-width: 767px)').matches;
      if (isMobile) {
        setInterval(function () {
          index = (index + 1) % slides.length;
          update();
        }, 4000);
      }

      // Start
      slides[0] && slides[0].classList.add('is-active');
      update();
    }).catch(function () { /* swallow */ });
  }

  function initAll() {
    var nodes = document.querySelectorAll('[data-amorosa-review]');
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      if (node.__amorosaInit) continue;
      node.__amorosaInit = true;
      renderInstance(node);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();